import React from "react"
import {breakpoints} from "@next/ux-fabric"
import urls from "../../../../config/urls"
import {FavouritesProps} from "../props"

const StandardFavourites = ({altText, hasFavourites, realm, variant, iconsVersionPath}: FavouritesProps) => {
    const {favourites} = urls
    const smallIconUrl = favourites.iconUrl(realm, variant, hasFavourites, "small", iconsVersionPath)
    const largeIconUrl = favourites.iconUrl(realm, variant, hasFavourites, "large", iconsVersionPath)

    const smallMediaQuery = `(max-width: ${breakpoints.values.md}px)`
    const largeMediaQuery = `(min-width: ${breakpoints.values.md + 1}px)`
    return (
        <picture>
            <source media={smallMediaQuery} srcSet={smallIconUrl} />
            <source media={largeMediaQuery} srcSet={largeIconUrl} />
            <img src={largeIconUrl} alt={altText} aria-hidden />
        </picture>
    )
}

export default StandardFavourites
